<script setup>
import DsProgressBar from "JIX/components/ds/DsProgressBar.vue";
import TestQuestion from 'JIX/components/talenttest/TestQuestion.vue';
import TestHelp     from 'JIX/components/talenttest/TestHelp.vue';
import TestWarn     from 'JIX/components/talenttest/TestWarn.vue';

import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import { useRefEventListener } from 'JIX/eventListener.js';

const helpModal = ref();
const warnModal = ref();

const store = useStore();

const questionsSize = computed(() => store.state.questionsSize);
const questionsAnswered = computed(() => store.getters.questionsAnswered);
const currentQuestion = computed(() => store.getters.currentQuestion);

const active = computed(() => currentQuestion.value.index >= 0);

useRefEventListener(ref(window), 'beforeunload', (event) => {
    if (!active.value) {
        return;
    }

    event.preventDefault();
    event.returnValue = '';
});

const progressLabel = "Gennemført";
const imageLabel = "Gå til forside af talenttest";

onMounted(() => store.commit('setWarnModal', warnModal));
</script>

<template>
    <section
        v-if="active"
        class="container overflow-hidden pt-0 pt-lg-4 pb-0 pb-lg-4 pl-0 pr-0 pl-lg-3 pr-lg-3"
    >
        <section class="talenttest bg-light pt-5 pb-4 pr-4 pl-4 pr-md-0 pl-md-0 pb-md-0 position-relative" aria-live="polite">
            <div class="position-relative">
                <div class="position-relative position-md-absolute text-center">
                    <a
                        href="/talenttest"
                        :aria-label="imageLabel"
                    >
                        <img
                            src="/img/jobindex20/talenttest/talents-unlimited-logo.png"
                            class="ml-0 ml-md-5"
                            style="width: 100px"
                            :title="imageLabel"
                        >
                    </a>
                </div>
            </div>
            <div class="text-center mb-md-4 mb-4 mt-4">
                <h1>
                    TT38 Talenttest
                </h1>
                <div class="row justify-content-center">
                    <div class="col-xs-12 col-md-6">
                        <p class="lead mb-4 d-none d-sm-block">
                            Svar ærligt og undgå at give neutrale svar. Forestil dig hvordan en god kollega ville svare på dine vegne, hvis du er i tvivl.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xs-12 col-md-8 col-lg-6 mb-5">
                    <DsProgressBar
                        :value="questionsAnswered"
                        :min="0"
                        :max="questionsSize"
                        :label="progressLabel"
                        class="mb-4 mt-3"
                        show-pct
                    />
                    <TestQuestion />
                </div>
            </div>

            <a
                class="help-button"
                @click="$refs.helpModal.show()"
            >
                Hjælp
            </a>

            <TestHelp ref="helpModal" />
            <TestWarn ref="warnModal" />
        </section>
    </section>

    <div v-else class="d-flex" style="min-height: 768px">
        <div class="mx-auto my-auto">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>
